module.exports = __webpack_public_path__ + "img/team-2.851f5dab.png";